import { faArrowRight } from "@fortawesome/pro-light-svg-icons"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { JoonUIColor, Typography } from "@joonapp/web-shared"

import useMobile from "../../hooks/useMobile"
import { useMissionsQuery } from "../../networking/missions/queries"
import { useFamilyQuery } from "../../networking/queries"
import useCareTeam from "../../pages/care/useCareTeam"
import useFamilyUserSelectStore from "../../pages/family/hooks/useFamilyUserSelect"
import useRewardsUserSelectStore from "../../pages/rewards/hooks/useRewardsUserSelectStore"
import { FamilyQuerySelect, MissionScene, MissionStatus } from "../../types"
import { useRouter } from "../../util/router"

const GetStartedMobileBanner = () => {
  const { data: missions } = useMissionsQuery()
  const { data: children } = useFamilyQuery(FamilyQuerySelect.CHILDREN)
  const firstChild = children?.[0]
  const router = useRouter()
  const { setSelectedUserId: setSelectedUserIdFamily } =
    useFamilyUserSelectStore()
  const { setSelectedUserId: setSelectedUserIdRewards } =
    useRewardsUserSelectStore()
  const mission = missions?.find(
    (mission) => mission.status.status === MissionStatus.INCOMPLETE
  )
  const isMobile = useMobile()
  const { firstTherapist } = useCareTeam()
  const isOnRouteWithNoBanner =
    router.pathname.includes("/care") ||
    router.pathname.includes("/coach") ||
    router.pathname.includes("/paywall") ||
    router.pathname.includes("/checkout")

  if (!mission || !isMobile || !!firstTherapist || isOnRouteWithNoBanner)
    return null

  const handleStart = () => {
    switch (mission.scene_name) {
      case MissionScene.FAMILY_TAB:
        router.push("/family")
        if (firstChild?.user.id) setSelectedUserIdFamily(firstChild?.user.id)
        break
      case MissionScene.QUEST_TAB:
        router.push("/quests")
        break
      case MissionScene.REWARDS_TAB:
        router.push("/rewards")
        if (firstChild?.user.id) setSelectedUserIdRewards(firstChild?.user.id)
    }
  }

  return (
    <button
      onClick={handleStart}
      className="w-full fixed bottom-[68px] z-[100] h-[56px]"
    >
      <div className="bg-indigo-700 rounded-t-lg p-4 gap-2 flex justify-between items-center">
        <Typography variant="bodySmall" color={JoonUIColor.text.inverted}>
          Getting started: {mission.title}
        </Typography>
        <FontAwesomeIcon
          icon={faArrowRight}
          color={JoonUIColor.icon.inverted}
        />
      </div>
    </button>
  )
}

export default GetStartedMobileBanner
